import React from 'react';
import { Link } from 'react-router-dom';
import { userShape } from '../../../utils/shapes';
import withSound from '../../../containers/withSounds';

function HeaderAdminLink({ user, ...otherProps }) {
  return user && user.isAdmin ? (
    <li role="presentation">
      <Link to="/admin" role="menuitem" {...otherProps}>
        Admin
      </Link>
    </li>
  ) : null;
}

HeaderAdminLink.propTypes = {
  user: userShape
};

export default withSound({ mouseEnterSound: true })(HeaderAdminLink);



// WEBPACK FOOTER //
// ./src/containers/Admin/HeaderAdminLink/index.js